import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ChevronLeftIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.6304 4.90004C17.021 5.29056 17.021 5.92373 16.6304 6.31425L10.3376 12.6071L16.6304 18.9C17.021 19.2906 17.021 19.9237 16.6304 20.3143C16.2399 20.7048 15.6068 20.7048 15.2162 20.3143L8.21623 13.3143C7.82571 12.9237 7.82571 12.2906 8.21623 11.9L15.2162 4.90004C15.6068 4.50952 16.2399 4.50952 16.6304 4.90004Z"
            />
        </SvgIcon>
    );
};

export default ChevronLeftIcon;
